<template>
  <div
    v-if="showOfficeTools"
    class="bg-orange p-4 mb-4"
  >
    <h5 data-i18n="info.forAgents">
      {{ $t('info.forAgents') }}
    </h5>
    <div class="flex flex-wrap -mx-4">
      <div class="w-12/12 sm:w-6/12 px-4">
        <div>
          <h5
            class="mb-4"
            data-i18n="info.forAgents.manager"
          >
            {{ $t('info.forAgents.manager') }}
          </h5>
          <a
            class="btn btn-orange btn-xl mb-4"
            :href="`mailto:${trip.product_manager.email}`"
          >
            <fa icon="envelope" />
            <span class="ml-2">
              {{ trip.product_manager.name }}
            </span>
          </a>
        </div>
      </div>
      <div class="w-12/12 px-4 mt-2">
        <strong data-i18n="tripType.id">
          {{ $t('tripType.id') }}
        </strong>
        <code class="ml-1">
          {{ trip?.id }}
        </code>
      </div>
    </div>
    <div
      v-if="faq.length > 0"
      class="product-bluebox mb-4 mt-5 !bg-transparent shadow-xl"
    >
      <i-info
        class="product-bluebox__ico"
        filled
        :font-controlled="false"
        alt="info"
      />
      <div class="product-itinerary__item_other_information">
        <div
          v-for="{question, answer, id} in faq"
          :key="id"
          class="product-itinerary__item_included my-2"
        >
          <span class="font-bold block">
            {{ question }}
          </span>
          <span>
            {{ answer }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia'

export default defineNuxtComponent({
  props: {
    trip: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      faq: [],
    }
  },

  computed: {
    ...mapState(useRootStore, {
      showOfficeTools: 'showOfficeTools',
      tripTypeInfo: 'trip',
    }),
  },

  created () {
    this.setupFaq()
  },

  methods: {
    ...mapActions(useTripStore, ['fetchFaq']),

    async setupFaq () {
      this.faq = await this.fetchFaq(this.trip?.id)
    },
  },
})
</script>
